import React from "react";
import { Link } from "react-router-dom";

interface Props {
    currentPage: number;
    lastPage: number;
    onChange: (page: number) => void;
}

/**
 * Pagination des écrans de visualisation des données.
 */
const PagerNav: React.FC<Props> = ({ currentPage, lastPage, onChange }) => {
    if (!lastPage || lastPage <= 1) {
        return null;
    }

    const items = [];

    if (currentPage > 1) {
        items.push(
            <li key="pagination-first" className="pagination__item">
                <Link className="pagination__item--link" to="#" onClick={() => onChange(1)}>
                    <i className="icon-angle-double-left-solid"></i>
                </Link>
            </li>
        );

        items.push(
            <li key="pagination-prev" className="pagination__item">
                <Link className="pagination__item--link" to="#" onClick={() => onChange(currentPage - 1)}>
                    <i className="icon-arrow-left"></i>
                </Link>
            </li>
        );
    }

    const minMax = 4;
    const pageMin = Math.max(1, Math.min(currentPage - minMax, lastPage - 2 * minMax));
    const pageMax = Math.min(lastPage, pageMin + 2 * minMax);

    for (let i = 1; i <= lastPage; i++) {
        if (i >= pageMin && i <= pageMax) {
            items.push(
                <li
                    key={`${i}-paginate`}
                    className={`pagination__item ${currentPage === i ? "pagination__item--active" : ""}`}
                >
                    <Link className="pagination__item--link" to="#" onClick={() => onChange(i)}>
                        {i}
                    </Link>
                </li>
            );
        }
    }

    if (currentPage < lastPage) {
        items.push(
            <li key="pagination-next" className="pagination__item">
                <Link className="pagination__item--link" to="#" onClick={() => onChange(currentPage + 1)}>
                    <i className="icon-arrow-right"></i>
                </Link>
            </li>
        );

        items.push(
            <li key="pagination-last" className="pagination__item">
                <Link className="pagination__item--link" to="#" onClick={() => onChange(lastPage)}>
                    <i className="icon-angle-double-right-solid"></i>
                </Link>
            </li>
        );
    }

    return (
        <nav className="pagination">
            <ul className="pagination__list">{items}</ul>
        </nav>
    );
};

export default PagerNav;
